import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useModal } from 'hooks/useModal';
import { modalName as downloadsModal } from 'modals/DownloadsModal';

export const DocumentsToolbarButtonDownloads = () => {
    const { openModal } = useModal();

    return (
        <Button
            type="text"
            onClick={() => openModal(downloadsModal)}
            icon={<DownloadOutlined />}
        >
            My Downloads
        </Button>
    );
};
